import {WixSdk} from '@wix/js-sdk-wrapper';
import {getQueryParams} from '@wix/music-shared/dist/src/utils/queryParams/queryParams';
import {initContextCapture} from '@wix/smartling-context-capture';
import 'normalize.css';
import React from 'react';
import ReactDOM from 'react-dom';
import styleProcessor from 'wix-style-processor';
import {I18nextProvider} from 'react-i18next';
import 'reflect-metadata';
import 'regenerator-runtime/runtime';
import 'whatwg-fetch';
import './_bootstrap';
import {App} from './containers/App';
import {createI18nInstance} from './createI18nInstance';
import './get-window.scss';
import {container} from './ioc/container';
import {inversifyConfig} from './ioc/inversify.config';
import {services} from './ioc/services';
import {installUnhandled} from './services/errorLogger/errorLogger';
import {debugPanel, settings} from './services/localConfig/debugPanel';

try {
  initContextCapture({
    enable: settings.enableSmartling,
  });
} catch (e) {
  console.error(e);
}

const baseUrl = window.__STATICS_BASE_URL__ || '';

__webpack_public_path__ = baseUrl; // eslint-disable-line
inversifyConfig(container);
installUnhandled();

if (window.configureContainer) {
  window.configureContainer(container, services);
}
debugPanel.start();
const queryParams = getQueryParams();

if (window.top === window || queryParams.viewMode === 'standalone') {
  WixSdk.Styles.getStyleParams = () => {
    return import('../test/fixtures/style/style-params.json');
  };

  WixSdk.Styles.getSiteColors = () => {
    return import('../test/fixtures/style/site-colors.json');
  };

  WixSdk.Styles.getSiteTextPresets = () => {
    return import('../test/fixtures/style/site-text-presets.json');
  };

  WixSdk.Activities.getUserSessionToken = () => Promise.resolve(queryParams.svSession || 'LOCAL_S_TOKEN');
  WixSdk.Activities.getUserSessionToken = () =>
    Promise.resolve(
      '8b7c4d14e8f52bd96ba3478ea96e78cb44308fea245e621bfa4eab13187c59a723cf3374521a64cb534e346c93e1b4981e60994d53964e647acf431e4f798bcd9984cd4c33682861087dc7ab823dd0fa3a8f02c3a152af474be320d24c495b22',
    );

  WixSdk.getSiteInfo = () => {
    return Promise.resolve({
      url: window.__SITE_URL__!,
      baseUrl: window.__SITE_URL__!,
      pageTitle: '',
      pageTitleOnly: '',
      referer: '',
      siteDescription: '',
      siteKeywords: '',
    });
  };
}

const render = async AppComponent => {
  const i18n = createI18nInstance({
    locale: window.__LOCALE__,
    translations: window.__TRANSLATIONS__,
    baseUrl,
  });
  await Promise.all([i18n.init(), styleProcessor.init()]);
  const container = document.getElementById('root')!;
  const element = (
    <I18nextProvider i18n={i18n}>
      <AppComponent />
    </I18nextProvider>
  );
  // Tolerate ejs/bundle version skew during gradual rollout: the bundle (createRoot) can be served
  // under a still-react@16 global. Feature-detect createRoot and fall back to ReactDOM.render.
  const createRoot = (ReactDOM as any).createRoot;
  if (createRoot) {
    createRoot(container).render(element);
  } else {
    ReactDOM.render(element, container);
  }
};
render(App);

// if ((module as any).hot) {
//   (module as any).accept('./components/App', () => {
//     render(require('./components/App').App);
//   });
// }

if (window.webpackHotUpdate) {
  const originalUpdate = window.webpackHotUpdate;
  window.webpackHotUpdate = (...args) => {
    document.querySelectorAll('link[href][rel=stylesheet]').forEach((link: any) => {
      const nextStyleHref = link.href.replace(/(\?\d+)?$/, `?${Date.now()}`);
      link.href = nextStyleHref;
    });
    originalUpdate(...args);
  };
}

window.info = () =>
  import('./services/env/info/info').then(module => {
    module.run();
  });
